import { useUiStore } from '@/state/uiStore';
import { useConfigStore } from '@/state/configStore';
import { useConstraintsStore } from '@/state/constraintsStore';
import { randomSeed } from '@/lib/seed';
import { buildShareUrl } from '@/model/serialization';
import { useState } from 'react';

export function Topbar() {
  const theme = useUiStore((s) => s.theme);
  const setTheme = useUiStore((s) => s.setTheme);
  const seed = useConstraintsStore((s) => s.seed);
  const setSeed = useConstraintsStore((s) => s.setSeed);
  const config = useConfigStore((s) => s.config);
  const [toast, setToast] = useState<string | null>(null);

  const flash = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(null), 1800);
  };

  const onShare = async () => {
    if (!config) return;
    const url = buildShareUrl(config);
    try {
      await navigator.clipboard.writeText(url);
      flash('Link copied');
    } catch {
      window.prompt('Copy this link', url);
    }
  };

  return (
    <>
      <header className="topbar panel" role="banner">
        <div className="brand">
          <span className="dot" aria-hidden="true" />
          <span>Structure</span>
        </div>
        <div className="spacer" />
        <label className="visually-hidden" htmlFor="seed-input">Seed</label>
        <input
          id="seed-input"
          type="text"
          className="seed"
          value={seed}
          onChange={(e) => setSeed(e.target.value)}
          spellCheck={false}
          style={{ width: 180 }}
        />
        <button type="button" onClick={() => setSeed(randomSeed())} title="New random seed" aria-label="New random seed">↻</button>
        <button type="button" onClick={onShare} disabled={!config} title="Copy share URL">
          Share
        </button>
        <button
          type="button"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? 'Light' : 'Dark'}
        </button>
      </header>
      {toast && <div className="toast" role="status">{toast}</div>}
    </>
  );
}
